class MultiLevel < ApplicationRecord
  belongs_to :dance
end
